import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
//image
import RouteMapImg1 from '../../assets/img/route104-map-img1.png';
import RouteMapImg2 from '../../assets/img/route104-map-img2.png';
import RouteMapImg3 from '../../assets/img/route104-map-img3.png';
import RouteMapImg4 from '../../assets/img/route104-map-img4.png';
//Map
// import RouteMapImg11 from '../../assets/img/route29-map-img1.png';
import RouteMapImg11 from '../../assets/img/route28-map-img1.png';
// import RouteMapImg11Eng from '../../assets/img/route29-map-img1-eng.png';
import RouteMapImg11Eng from '../../assets/img/route28-map-img1-eng.png';

const RouteMap = ({language}) => {
    return (
        <section className="route-map">
            <h5><span>{language === "Chinese" ? "路線地圖" : "Route Map"}</span></h5>
            <Container>
                <Row className='align-items-center'>
                    <Col md={6}>
                        <Row className='align-items-center'>
                            <Col>
                                <h2>
                                    <span className='theme-color'><em>28K</em></span>
                                </h2>
                                <p>{language === "Chinese" ? "路線長度" : "DISTANCE"}</p>
                            </Col>
                            <Col>
                                <h2><span className='theme-color'><em>+650m</em></span></h2>
                                <p>{language === "Chinese" ? "爬升高度" : "ELEVATION GAIN"}</p>
                            </Col>
                        </Row>
                        <Row className='align-items-center pl-5 mt-5'>
                            <div className="route-map-bx">
                                <div className="map-logo">
                                    <img src={RouteMapImg1} alt="" />
                                    <img src={RouteMapImg2} alt="" />
                                </div>
                                <h3>{language === "Chinese" ? "起點：向山遊客中心" : "Start: Xiangshan Visitor Center"} <span className='theme-color'><em>0K</em></span></h3>
                            </div>
                            <div className="route-map-bx">
                                <div className="map-logo">
                                    <img src={RouteMapImg3} alt="" />
                                </div>
                                <h3>{language === "Chinese" ? "終點：向山遊客中心" : "Finish: Xiangshan Visitor Center"} <span className='theme-color'><em>28K</em></span></h3>
                            </div>
                            <div className="route-map-bx">
                                <div className="map-logo">
                                    <img src={RouteMapImg4} alt="" />
                                </div>
                                <h3>{language === "Chinese" ? "環法小鎮：向山遊客中心" : "Race Village: Xiangshan Visitor Center"} <span className='theme-color'><em>0K</em></span></h3>
                            </div>
                            <p className='small-text mt-5'>{language === "Chinese" ? "※本組設置為純挑戰路段，鼓勵大家體驗環法騎乘樂趣氛圍！" : "*This category is a pure challenge ride — come and enjoy the thrill and atmosphere of riding the Tour de France way!"}</p>
                            <p className='small-text'>{language === "Chinese" ? "※本組別沿日月潭環湖公路以順時針方向騎乘，請勿騎入103K路線；下坡路段彎道多，請減速慢行。" : "*This route circles Sun Moon Lake clockwise. Do not enter the 103K course. The descents are twisty, so please slow down."}</p>
                            <p className='small-text'>{language === "Chinese" ? "※本組別沿途無設置補給站，建議車手可視自身情況攜帶補給品與能量飲食。" : "*There are no aid stations on this route. Riders are advised to carry their own food, drinks and energy supplies as needed."}</p>
                        </Row>
                    </Col>
                    <Col md={6}>
                        {language === 'Chinese' ? <img src={RouteMapImg11} alt="路線地圖" /> : <img src={RouteMapImg11Eng} alt="Route map" />}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default RouteMap